import { apiGet, apiPost, apiPatch, apiDelete } from "../../shared/http.js";
import {
  MealPlanResponseSchema,
  MealPlansResponseSchema,
  CreateMealPlanRequestSchema,
  PatchMealPlanRequestSchema,
  type MealPlanApiItem,
  type MealPlansResponse,
  type CreateMealPlanRequest,
  type PatchMealPlanRequest,
} from "@recipevault/shared";

interface ListOpts {
  updatedSince?: string;
  cursor?: string;
}

export async function listMealPlans(opts: ListOpts = {}): Promise<MealPlansResponse> {
  const qs = new URLSearchParams();
  if (opts.updatedSince) qs.set("updatedSince", opts.updatedSince);
  if (opts.cursor) qs.set("cursor", opts.cursor);
  const raw = await apiGet<unknown>(qs.toString() ? `/meal-plans?${qs}` : "/meal-plans");
  return MealPlansResponseSchema.parse(raw);
}

export async function getMealPlan(weekStart: string): Promise<MealPlanApiItem> {
  return MealPlanResponseSchema.parse(await apiGet<unknown>(`/meal-plans/${weekStart}`)).plan;
}

// No idempotencyKey — the week's natural key (weekStart) makes create idempotent
// server-side, unlike shopping lists / recipes which need a client-generated key.
export async function createMealPlan(body: CreateMealPlanRequest): Promise<MealPlanApiItem> {
  CreateMealPlanRequestSchema.parse(body);
  return MealPlanResponseSchema.parse(await apiPost<unknown>("/meal-plans", body)).plan;
}

export async function patchMealPlan(
  weekStart: string,
  body: PatchMealPlanRequest,
): Promise<MealPlanApiItem> {
  PatchMealPlanRequestSchema.parse(body);
  return MealPlanResponseSchema.parse(await apiPatch<unknown>(`/meal-plans/${weekStart}`, body))
    .plan;
}

export async function deleteMealPlan(weekStart: string): Promise<void> {
  await apiDelete(`/meal-plans/${weekStart}`);
}
